import type { ProfileFieldResponse, ProfileSectionResponse } from "@services/facilityManagement";

/** Parent-hospital fields shown only for provider-based RHC/FQHC (AB#10122). */
export const PROVIDER_BASED_PARENT_HOSPITAL_FIELD_KEYS = new Set<string>([
  "parent_hospital_licensed_bed_count",
  "parent_hospital_is_cah",
  "parent_hospital_ccn",
]);

export const PROVIDER_BASED_STATUS_VALUE = "provider_based";

function unwrapProfileValue(v: unknown): string | null {
  if (v === null || v === undefined) return null;
  if (typeof v === "object" && v !== null && "value" in v) {
    const inner = (v as { value: unknown }).value;
    if (inner === null || inner === undefined) return null;
    const s = String(inner).trim();
    return s || null;
  }
  const s = String(v).trim();
  return s || null;
}

/** Hide parent-hospital fields unless provider-based status is provider_based. */
export function applyProviderBasedFieldOverrides(
  field: ProfileFieldResponse,
  providerBasedStatusRaw: unknown,
): ProfileFieldResponse {
  if (!PROVIDER_BASED_PARENT_HOSPITAL_FIELD_KEYS.has(field.field_key)) {
    return field;
  }
  const status = (unwrapProfileValue(providerBasedStatusRaw) ?? "").trim();
  if (status === PROVIDER_BASED_STATUS_VALUE) {
    return field;
  }
  return { ...field, visible: false, is_required: false };
}

export function mergeProviderBasedSectionForDisplay(
  section: ProfileSectionResponse,
  providerBasedStatusRaw: unknown,
): ProfileSectionResponse {
  if (section.section_key !== "certification_enrollment") return section;
  return {
    ...section,
    fields: section.fields.map((f) =>
      applyProviderBasedFieldOverrides(f, providerBasedStatusRaw),
    ),
  };
}
